/**
 * Active entry: functional forgot-password page.
 * Legacy class: ./ForgotPassword.js
 */
import ForgotPasswordPage from "./ForgotPasswordPage";

export default ForgotPasswordPage;
